import React, { useState } from 'react';
import { Picker, PickerProps } from 'antd-mobile';
import { PickerValue } from 'antd-mobile/es/components/picker-view';

const hours = Array.from({ length: 24 }, (_, i) => {
  return {
    label: String(i).padStart(2, '0'),
    value: String(i).padStart(2, '0'),
  };
});

const minutes = Array.from({ length: 60 }, (_, i) => {
  return {
    label: String(i).padStart(2, '0'),
    value: String(i).padStart(2, '0'),
  };
});

const columns = [[...hours], [...minutes]];

type Props = {
  setVisible: (visible: boolean) => void;
} & Partial<PickerProps>;

const TimePicker: React.FC<Props> = ({ setVisible, visible, ...props }) => {
  const [value, setValue] = useState<PickerValue[]>([]);

  return (
    <Picker
      {...props}
      columns={columns}
      onClose={() => {
        setVisible(false);
      }}
      onConfirm={(v) => {
        setValue(v);
      }}
      value={value}
    />
  );
};

export default TimePicker;
